import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  imports: [MatIconModule],
  template: `
    <span class="snackbar-content">
      <mat-icon style="color: {{ data.iconColor ?? '#fff000' }}" class="snackbar-icon" aria-hidden="true">{{ data.icon }}</mat-icon>
      <span [innerHTML]="data.message"></span>
    </span>
  `,
  styles: [
    `
      .snackbar-content {
        display: flex;
        align-items: center;
      }
      .snackbar-icon {
        margin-right: 12px;
        flex-shrink: 0;
      }
    `,
  ],
})
export class CustomSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
